import { Badge, IconButton, useTheme } from '@mui/material'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import { useLocation, useNavigate } from 'react-router-dom'
import { useCart } from 'api/hooks/use-cart'
import { useTranslation } from 'react-i18next'
import { pageConfig } from 'app/page-config'

export const CartHeaderButton = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const location = useLocation()
  const navigate = useNavigate()
  const { data } = useCart()
  const totalPrice = data.totalPrice
  const maxPrice = 999999
  const notificationsLabel = (price: number) => {
    if (!price || price === 0) {
      return t('empty_cart')
    }
    if (price > maxPrice) {
      return t('more_than_max_price', {
        max: maxPrice,
      })
    }
    return `${price} грн`
  }

  const button = (
    <IconButton
      aria-label={notificationsLabel(totalPrice)}
      onClick={() => navigate(pageConfig.cart, { state: { from: location } })}
      sx={{ '&:hover': { backgroundColor: theme.palette.primary.light } }}
      size="small"
    >
      <ShoppingCartOutlinedIcon color="primary" sx={{ fontSize: '23px' }} />
    </IconButton>
  )

  return totalPrice > 0 ? (
    <Badge
      badgeContent={`${totalPrice} грн`}
      color="primary"
      overlap="circular"
      max={maxPrice}
      sx={{
        '& span': {
          top: '-4px',
          right: '50%',
          fontSize: '10px',
          color: theme.palette.common.white,
          textWrap: 'nowrap',
        },
      }}
    >
      {button}
    </Badge>
  ) : (
    button
  )
}
